import { sidebarSpaceThreadsToggledEvent } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
export function useSpaceExpansion({ defaultExpanded }) {
    const [expandedBySpaceKey, setExpandedBySpaceKey] = useLocalUserSettings('sidebarPromotedSpaceExpanded', {});
    const { track } = useInstrumentation();
    const setExpanded = useCallback((spaceKey, expanded) => {
        setExpandedBySpaceKey((currentValue) => ({
            ...currentValue,
            [spaceKey]: expanded ?? !(currentValue[spaceKey] ?? defaultExpanded),
        }));
    }, [defaultExpanded, setExpandedBySpaceKey]);
    const trackToggle = useCallback((spaceUuid, expanded) => {
        track(sidebarSpaceThreadsToggledEvent({
            name: 'sidebar space threads toggled',
            data: { action: expanded ? 'expand' : 'collapse', collectionUUID: spaceUuid },
        }));
    }, [track]);
    return { expandedBySpaceKey, setExpanded, trackToggle };
}
//# sourceMappingURL=useSpaceExpansion.js.map